import {
	type BaseQueryApi,
	type FetchArgs,
	fetchBaseQuery,
} from "@reduxjs/toolkit/query/react";
import Cookies from "js-cookie";
import { logout } from "../../entities/Auth/authApi";
import type { RootState } from "./store";

const baseQuery = fetchBaseQuery({
	baseUrl: process.env.REACT_APP_API_BASE_URL,
	credentials: "include",
	prepareHeaders: (headers, { getState }) => {
		const token = (getState() as RootState).auth.token || Cookies.get("token");
		if (token) {
			headers.set("Authorization", `Bearer ${token}`);
		}
		return headers;
	},
});

export const baseQueryWithInterceptors = async (
	args: string | FetchArgs,
	api: BaseQueryApi,
	extraOptions: object,
) => {
	const result = await baseQuery(args, api, extraOptions);

	if (result?.error && result.error.status === 401) {
		const needsInterceptor = !(
			(typeof args === "string" && args.includes("/users/login")) ||
			(typeof args === "string" && args.includes("/users/register")) ||
			(typeof args === "object" && args.url.includes("/users/login")) ||
			(typeof args === "object" && args.url.includes("/users/register"))
		);

		if (needsInterceptor) {
			Cookies.remove("token");
			api.dispatch(logout());
			window.location.href = "/login";
		}
	}

	return result;
};
